$('.block-blog-posts-grid').each(function() {

	const slider = $(this);

	let opts = {
        allowTouchMove: true,
        keyboard: {
            enabled: true,
        },
		loop: false,
		speed: 500,
		navigation: {
			nextEl: slider.find('.swiper-arrow.next')[0],
			prevEl: slider.find('.swiper-arrow.prev')[0],
		},
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            960: {
                pagination: {
                    clickable: false,
                    el: slider.find('.swiper-numbers')[0],
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + (index + 1) + "</span>";
                    },
                },
                slidesPerGroup: 3,
                slidesPerView: 3,
            },
            1280: {
                allowTouchMove: false,
                grid: {
                    fill: 'row',
                    rows: 2,
                },
                pagination: {
                    clickable: false,
                    el: slider.find('.swiper-numbers')[0],
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + (index + 1) + "</span>";
                    },
                },
                slidesPerView: 3,
            },
        },
	};

	const swiper = new Swiper($(this).find('.swiper')[0], opts);

});
